let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Rd5w")).then(() => parcelRequire('7kxKW'));